import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const API_PREFIX = ""; // keep consistent with your app

const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export default function ArtistsPage() {
  const [covers, setCovers] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_PREFIX}/api/covers`);
        if (!res.ok) throw new Error(`Failed: ${res.status}`);
        const data = await res.json();
        setCovers(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(e);
        setError("Could not load artists.");
      }
    })();
  }, []);

  const artists = useMemo(() => {
    const map = new Map();
    for (const c of covers) {
      const name = (c.artist || "").trim();
      if (!name) continue;
      const key = name.toLowerCase();
      map.set(key, { name, count: (map.get(key)?.count || 0) + 1 });
    }
    return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [covers]);

  return (
    <main className="main-content">
      <h2 style={{ marginTop: 18 }}>Artists</h2>
      {error && <p>{error}</p>}

      <div style={{ display: "grid", gap: 10, marginTop: 12 }}>
        {artists.map((a) => (
          <Link
            key={a.name}
            to={`/artists/${slugify(a.name)}`}
            style={{
              border: "1px solid rgba(212,175,55,0.35)",
              borderRadius: 12,
              padding: 12,
              textDecoration: "none",
              color: "#ffd700",
              background: "#050505",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <span style={{ fontWeight: 700 }}>{a.name}</span>
            <span style={{ opacity: 0.8 }}>{a.count}</span>
          </Link>
        ))}
      </div>
    </main>
  );
}
